import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'zef-button-progress',
  templateUrl: './button-progress.component.html',
  styleUrls: [ './button-progress.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonProgressComponent {
  @Input()
  set active(v: string | boolean) {
    this._active = coerceBooleanProperty(v);

    if (this.buttonRef) {
      setTimeout(() => {
        if (!this.disabled) {
          this.buttonRef.disabled = this.active;
          this._cdRef.markForCheck();
        }
      });
    }
  }
  get active(): boolean {
    return this._active;
  }

  @Input()
  disabled: boolean;

  @Input()
  buttonRef: MatButton;

  private _active: boolean;

  constructor(private _cdRef: ChangeDetectorRef) { }

}
